<script lang="ts">
  import { appVersion } from "../env";
  import Locale from "./locale.svelte";
  import Masthead from "./masthead.svelte";

  export let hero: string | null;
  export let whiteLabel: string | null;
</script>

<div class="Container">
  <div class="Dialog">
    <Masthead src={hero} alt="Welcome" />

    <div class="Body">
      {#if whiteLabel}
        {@html whiteLabel}
      {:else}
        <p>
          <b><Locale label="appInfo.applicationBy" /></b>
          <a href="https://www.smartparks.co" target="_blank"> Smartparks LLC </a>
        </p>
      {/if}

      <p>
        <b><Locale label="appInfo.version" /></b>
        <code>{appVersion}</code>
      </p>
    </div>
  </div>
</div>

<style>
  .Container {
    background: var(--theme-bg-elevation-1);
    flex: 1 1 auto;
    height: 100%;
    overflow: hidden;
    width: 100%;
  }

  .Dialog {
    background: white;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .Body {
    padding-block: var(--outer-padding);
    padding-left: max(env(safe-area-inset-left), var(--outer-padding));
    padding-right: max(env(safe-area-inset-right), var(--outer-padding));
  }
</style>
